@if (cellType === CellType.Date) {
    <!-- Affichage des cellules de type 'Date' -->
    <span>
        {{ data | avmHistoryCellPipe: column | date: FRENCH_DATETIME_FORMAT }}
    </span>
} @else if (cellType === CellType.DateAndTime) {
    <!-- Affichage des cellules de type 'Date & heure' -->
    <span>
        {{ data | avmHistoryCellPipe: column | date: FRENCH_DATETIME_FORMAT }}
    </span>
} @else if (cellType === CellType.Enum && column.propertyCode === SEVERITY) {
    <!-- Affichage des icones de la colonne type du tableau des Actions -->
    @switch (data.severityLevel) {
        @case (SeverityLevel.Info) {
            <!--  Aucune icone -->
        }
        @case (SeverityLevel.Warning) {
            <mat-icon matTooltip="Avertissement">warning</mat-icon>
        }
        @case (SeverityLevel.Error) {
            <mat-icon matTooltip="Erreur">report</mat-icon>
        }
    }
} @else if (cellType === CellType.Enum && column.propertyCode === TYPE) {
    <!-- Affichage des icones de la colonne type du tableau des Actions -->
    @switch (data.type) {
        @case (ActionType.Comment) {
            <mat-icon matTooltip="Commentaire">mode_comment</mat-icon>
        }
        @case (ActionType.Move) {
            <mat-icon matTooltip="Déplacement">move_to_inbox</mat-icon>
        }
        @case (ActionType.Merge) {
            <mat-icon matTooltip="Fusion">add_link</mat-icon>
        }
        @case (ActionType.Add) {
            <mat-icon matTooltip="Ajout de document">note_add</mat-icon>
        }
        @case (ActionType.Send) {
            <mat-icon matTooltip="Envoi de mail">send</mat-icon>
        }
        @case (ActionType.UpdateAttribute) {
            <mat-icon matTooltip="Modification d'attribut">edit_attributes</mat-icon>
        }
        @case (ActionType.UpdateWorkflow) {
            <mat-icon matTooltip="Modification du workflow">edit</mat-icon>
        }
        @case (ActionType.Create) {
            <mat-icon matTooltip="Création d'un dossier">create_new_folder</mat-icon>
        }
        @case (ActionType.Workflow) {
            <mat-icon matTooltip="Événement de workflow">electric_bolt</mat-icon>
        }
        @case (ActionType.Delete) {
            <mat-icon matTooltip="Suppression">delete_outline</mat-icon>
        }
        @case (ActionType.Process) {
            <mat-icon matTooltip="Processus">settings</mat-icon>
        }
        @case (ActionType.Reminder) {
            <mat-icon matTooltip="Rappel">event</mat-icon>
        }
        @case (ActionType.Clone) {
            <mat-icon matTooltip="Duplication">content_copy</mat-icon>
        }
        @case (ActionType.Archiving) {
            <mat-icon matTooltip="Archivage">inventory_2</mat-icon>
        }
        @case (ActionType.SendSms) {
            <mat-icon matTooltip="Envoi de SMS">sms</mat-icon>
        }
    }
} @else if (cellType === CellType.Standard) {
    <!-- Affichage des cellules standards -->
    <span class="overflow-ellipsis" [title]="data | avmHistoryCellPipe: column">
        {{ data | avmHistoryCellPipe: column }}
    </span>
}
